module.exports = __webpack_public_path__ + "static/media/Icons_outcome.5148d026.svg";